export default __webpack_public_path__ + "static/nya-casino-satsar-pa-snabbhet-b0900cd5387886cc653690e238171aa6.jpg";